import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        profile: () => executeCall(() => Axios.get(url, { headers: getHeaders() })),
        updateImage: (data) => executeCall(() => Axios.patch(url + '/img', data, { headers: getHeaders() })),
        update: (data) => executeCall(() => Axios.patch(url, data, { headers: getHeaders() })),
        assignmentResponse: (data) => executeCall(() => Axios.post(url + '/assignment-response', data, { headers: getHeaders() })),
        removeAssignment: (data) => executeCall(() => Axios.post(url + '/remove-assignment', data, { headers: getHeaders() })),
    };
};


export default crudder;